module.exports = __webpack_public_path__ + "img/a3cc11dee5e8852088ff56a13c647876.png";